/**
 * External dependencies
 */
import Cookies from 'js-cookie';

const Locations = ( () => {
	let locationSelect;
	let button;
	let options;
	let debounceTimeout;
	let isOpen = false;

	function showOptions() {
		if ( isOpen ) {
			hideOptions();
		} else {
			options.setAttribute( 'aria-expanded', 'true' );
			clearTimeout( debounceTimeout );
			document.addEventListener( 'click', outsideClickListener );
			isOpen = true;
		}
	}

	function hideOptions() {
		options.removeAttribute( 'aria-expanded' );
		document.removeEventListener( 'click', outsideClickListener );
		isOpen = false;
	}

	function selectLocation( e ) {
		e.preventDefault();

		const selectedLocationSlug = e.target.getAttribute( 'data-location' );

		Cookies.set( 'photobooths_location', selectedLocationSlug );

		hideOptions();

		// Refresh page.
		window.location.reload();
	}

	function outsideClickListener( e ) {
		if ( ! locationSelect.contains( e.target ) ) {
			hideOptions();
		}
	}

	function init( selector ) {
		locationSelect = document.querySelector( selector );
		if ( ! locationSelect ) {
			console.error( `Element with selector '${ selector }' not found.` );
			return;
		}
		button = locationSelect.querySelector(
			'.wp-block-photobooths-header__location-selected'
		);
		options = locationSelect.querySelector(
			'.wp-block-photobooths-header__location-options'
		);

		button.addEventListener( 'click', showOptions );
		options.addEventListener( 'click', selectLocation );
	}

	return {
		init,
	};
} )();

export default Locations;
